import { useState, useEffect } from 'react'
import { useNavigate } from 'react-router-dom';
import Swal from 'sweetalert2'
import { FaEye, FaEyeSlash } from "react-icons/fa";
import './AlterarSenha.css';

function getCookie(nome) {
    var nomeEQ = nome + "=";
    var ca = document.cookie.split(';');
    for(var i=0;i < ca.length;i++) {
      var c = ca[i];
      while (c.charAt(0)===' ') c = c.substring(1,c.length);
      if (c.indexOf(nomeEQ) === 0) return c.substring(nomeEQ.length,c.length);
    }
    return null;
}


const AlterarSenha = () => {

    const [tokenUrl, setTokenUrl] = useState('');
    const [obrigatorio, setObrigatorio] = useState(false);

    useEffect(() => {
        const params = new URLSearchParams(window.location.search);
        const token = params.get('token');
        const obrigatorioFlag = params.get('obrigatorio') === 'true';

        setTokenUrl(token || '');
        setObrigatorio(obrigatorioFlag);

        if (!token) {
            Swal.fire({
                title: "Token inválido",
                text: "Link de alteração de senha inválido ou expirado.",
                icon: "error"
            }).then(() => {
                window.location.href = "/";
            });
        }
    }, []);

    const [chave, setChave] = useState('')
    const [confirmChave, setConfirmChave] = useState('')
    const [showChave, setShowChave] = useState(false);
    const [showConfirmChave, setShowConfirmChave] = useState(false);
    const navigate = useNavigate();
    const [criterios, setCriterios] = useState({
        comprimento: false,
        maiusculas: false,
        minusculas: false,
        numeros: false,
        especiais: false,
        iguais: false
    });

    const btn_visibilidade_chave = () => {
        setShowChave((prev) => !prev);
        var x = document.getElementById("iptNovaSenha");
        if (x.type === "password") {
          x.type = "text";
        } else {
          x.type = "password";
        }
    };

    const btn_visibilidade_confirmar_chave = () => {
        setShowConfirmChave((prev) => !prev);
        var x = document.getElementById("iptConfirmarNovaSenha");
        if (x.type === "password") {
          x.type = "text";
        } else {
          x.type = "password";
        }
    };

const cadastrar_nova_senha = async (evento) => {
    evento.preventDefault();

    // Verificar critérios da senha
    const todosCriteriosAtendidos = Object.values(criterios).every(Boolean);
    if (!todosCriteriosAtendidos) {
        Swal.fire({
            title: "Senha não atende aos requisitos",
            text: "Por favor, verifique todos os critérios de senha segura.",
            icon: "error"
        });
        return;
    }

    try {
        Swal.fire({
            title: "Atualizando senha...",
            allowOutsideClick: false,
            didOpen: () => Swal.showLoading()
        });

        let response;
        let data;

        if (obrigatorio) {
            const tokenCookie = getCookie("info");
            if (!tokenCookie) {
                Swal.fire({
                    title: "Sessão expirada",
                    text: "Por favor, faça login novamente.",
                    icon: "error"
                }).then(() => navigate("/"));
                return;
            }

            response = await fetch(`${process.env.REACT_APP_API_URL}/api/autenticacoes/alterar_senha_obrigatoria`, {
                method: "POST",
                headers: {
                    "Content-Type": "application/json",
                    "Authorization": `Bearer ${tokenCookie}`
                },
                body: JSON.stringify({
                    password: chave,
                    confirmPassword: confirmChave
                })
            });
        } else {
            if (!tokenUrl) {
                throw new Error("Link de alteração inválido ou expirado.");
            }

            response = await fetch(`${process.env.REACT_APP_API_URL}/api/autenticacoes/alterar_senha`, {
                method: "POST",
                headers: {
                    "Content-Type": "application/json"
                },
                body: JSON.stringify({
                    token: tokenUrl,
                    password: chave,
                    confirmPassword: confirmChave
                })
            });
        }

        data = await response.json();

        if (!response.ok || data.status === "erro") {
            throw new Error(
                Array.isArray(data.mensagem) ? data.mensagem.join("\n") : (data.mensagem || "Erro ao alterar senha")
            );
        }

        Swal.fire({
            title: "Sucesso!",
            text: data.mensagem || "Senha alterada com sucesso.",
            icon: "success"
        }).then(() => {
            navigate("/");
        });
    } catch (error) {
        Swal.fire({
            title: "Erro",
            text: error.message,
            icon: "error"
        });
        console.error("Erro ao alterar senha:", error);
    }
};

    const detectar_tecla_enter = (evento) => {
        if (evento.key === 'Enter') {
            cadastrar_nova_senha(evento); // Chama a função ao pressionar Enter
        }
    };

    const verificar_chave = (e) => {
        const novaSenha = e.target.value;
        setChave(novaSenha);
        
        setCriterios((prev) => ({
            ...prev,
            ...verificar_criterios_senha(novaSenha),
            iguais: novaSenha === confirmChave && confirmChave.length > 0 // Só marca como igual se o usuário já digitou algo no campo de confirmação
        }));
    };
    
    const verificar_confirmar_chave = (e) => {
        const novaSenhaConfirmacao = e.target.value;
        setConfirmChave(novaSenhaConfirmacao);
    
        setCriterios((prev) => ({
            ...prev,
            iguais: chave === novaSenhaConfirmacao && novaSenhaConfirmacao.length > 0 // Só verifica se ambas não estão vazias
        }));
    };

    const verificar_criterios_senha = (senha) => {

        return {
            comprimento: senha.length >= 9,
            maiusculas: /[A-Z].*[A-Z]/.test(senha),
            minusculas: /[a-z].*[a-z]/.test(senha),
            numeros: /\d.*\d/.test(senha),
            especiais: /[!@#$%&*()_;].*[!@#$%&*()_;]/.test(senha)
           
        };
    };


    return (
        <div className="recover-box">
            <img src="lockus-icon.svg" className="logo" alt="Logo"/>
            <h1>Lockus</h1>
            <h4>Alterar senha</h4>

            {obrigatorio && (
                <div className="aviso-obrigatorio">
                    <strong>Atenção!</strong> Para sua segurança, altere sua senha antes de continuar.
                </div>
            )}

            <div className= "input-box">
                <input 
                    id="iptNovaSenha"
                    type="password" 
                    placeholder='Nova senha'
                    value={chave}
                    onChange={verificar_chave}
                    onKeyDown={detectar_tecla_enter}
                    required
                    maxLength={50}
                    aria-describedby="passwordHelp"
                />
                <button type="button" className="eye-icon" onClick={btn_visibilidade_chave}>
                    {showChave ? <FaEye  /> : <FaEyeSlash />}
                </button>
                
            </div>
            <div className= "input-box">
                <input 
                    id="iptConfirmarNovaSenha"
                    type="password"
                    placeholder='Confirmar nova senha'
                    value={confirmChave}
                    onChange={verificar_confirmar_chave}
                    onKeyDown={detectar_tecla_enter}
                    required
                    maxLength={50}
                    aria-describedby="confirmPasswordHelp"
                />
                <button type="button" className="eye-icon" onClick={btn_visibilidade_confirmar_chave}>
                    {showConfirmChave ? <FaEye  /> : <FaEyeSlash />}
                </button>
            </div>

            <ul className="checklist">
                <li className={criterios.comprimento ? "check" : ""}>
                    {criterios.comprimento ? "✅" : "❌"} Pelo menos 9 caracteres
                </li>
                <li className={criterios.maiusculas ? "check" : ""}>
                    {criterios.maiusculas ? "✅" : "❌"} Pelo menos 2 letras maiúsculas
                </li>
                <li className={criterios.minusculas ? "check" : ""}>
                    {criterios.minusculas ? "✅" : "❌"} Pelo menos 2 letras minúsculas
                </li>
                <li className={criterios.numeros ? "check" : ""}>
                    {criterios.numeros ? "✅" : "❌"} Pelo menos 2 números
                </li>
                <li className={criterios.especiais ? "check" : ""}>
                    {criterios.especiais ? "✅" : "❌"} Pelo menos 2 caracteres especiais (!@#$%&*()_;)
                </li>
                <li className={criterios.iguais ? "check" : ""}>
                    {criterios.iguais ? "✅" : "❌"} Senhas iguais
                </li>
            </ul>

            <button onClick={cadastrar_nova_senha} >Alterar senha</button>
        </div>
    );
}

export default AlterarSenha;
